// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M4.16797 12.5003C3.3914 12.5003 3.00311 12.5003 2.69683 12.3735C2.28845 12.2043 1.96399 11.8798 1.79484 11.4715C1.66797 11.1652 1.66797 10.7769 1.66797 10.0003V4.33366C1.66797 3.40024 1.66797 2.93353 1.84962 2.57701C2.00941 2.2634 2.26438 2.00844 2.57798 1.84865C2.9345 1.66699 3.40121 1.66699 4.33464 1.66699H10.0013C10.7779 1.66699 11.1662 1.66699 11.4724 1.79386C11.8808 1.96302 12.2053 2.28747 12.3744 2.69585C12.5013 3.00214 12.5013 3.39042 12.5013 4.16699M10.168 18.3337H15.668C16.6014 18.3337 17.0681 18.3337 17.4246 18.152C17.7382 17.9922 17.9932 17.7372 18.153 17.4236C18.3346 17.0671 18.3346 16.6004 18.3346 15.667V10.167C18.3346 9.23357 18.3346 8.76686 18.153 8.41034C17.9932 8.09674 17.7382 7.84177 17.4246 7.68198C17.0681 7.50033 16.6014 7.50033 15.668 7.50033H10.168C9.23455 7.50033 8.76784 7.50033 8.41132 7.68198C8.09771 7.84177 7.84275 8.09674 7.68296 8.41034C7.5013 8.76686 7.5013 9.23357 7.5013 10.167V15.667C7.5013 16.6004 7.5013 17.0671 7.68296 17.4236C7.84275 17.7372 8.09771 17.9922 8.41132 18.152C8.76784 18.3337 9.23455 18.3337 10.168 18.3337Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const IconCopy = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconCopy;
